import { Component } from '@angular/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ToastService } from '../../../shared/services/toast.service';
import { ToastState as ts } from '../../../shared/enums/toast-state.enum';
import { InputComponent } from '../../../shared/components/input/input.component';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../../../shared/components/table/table.component';
import { MotoristaGerenciamentoDTO } from '../models/motorista-gerenciamento';
import { BiometriaService } from '../../../shared/services/biometria.service';
import { TegelModule } from '@scania/tegel-angular-17';
import { TableHeader } from '../../../shared/models/table-header';
import { ModalService } from '../../../shared/services/modal.service';
import { ButtonVariant } from '../../../shared/enums/button-variant.enum';
import { DialogAtualizarMotoristaComponent } from './dialog-atualizar-motorista/dialog-atualizar-motorista.component';
import { MatDialog } from '@angular/material/dialog';
import { CpfMaskDirective } from '../../../shared/directives/cpf-mask.directive';
import { CpfHelper } from '../../../shared/helpers/cpf.helper';

@Component({
  selector: 'app-identificacao',
  imports: [
    ButtonComponent,
    InputComponent,
    FormsModule,
    TableComponent,
    TegelModule,
    CpfMaskDirective,
  ],
  templateUrl: './identificacao.component.html',
  styleUrl: './identificacao.component.scss',
})
export class IdentificacaoComponent {
  driverIdSearch: string = '';

  driversList: MotoristaGerenciamentoDTO[] = [];

  headers: TableHeader[] = [
    { value: 'driverId', label: 'Documento' },
    { value: 'nomeMot', label: 'Nome do Motorista' },
    { value: 'fornMot', label: 'Fornecedor' },
  ];

  constructor(
    private toast: ToastService,
    private service: BiometriaService,
    private modal: ModalService,
    private dialog: MatDialog,
  ) {}

  search() {
    if (!this.driverIdSearch || this.driverIdSearch.trim() === '') {
      this.driversList = [];
      return;
    }

    const cpfLimpo = CpfHelper.clean(this.driverIdSearch);

    this.service.getRegisteredDriver(cpfLimpo).subscribe({
      next: (value) => {
        if (value && value.content) {
          this.driversList = [value.content];
        } else {
          this.driversList = [];
        }
      },
      error: (e) => {
        this.driversList = [];
        this.toast.showToast(
          ts.error,
          e.error[0] ?? 'Falha ao carregar motorista.',
        );
      },
    });
  }

  edit(driver: MotoristaGerenciamentoDTO) {
    const dialogRef = this.dialog.open(DialogAtualizarMotoristaComponent, {
      data: { motorista: driver },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.driversList = [result.content];
      }
    });
  }

  confirmDelete(driver: MotoristaGerenciamentoDTO) {
    const dialog = this.modal.openConfirmationModal(
      'Exclusão de Biometria',
      `Deseja mesmo excluir a biometria de ${driver.nomeMot}?`,
      'Excluir',
      ButtonVariant.d,
      'Cancelar',
      ButtonVariant.s,
    );
    dialog.subscribe((result) => {
      if (result) {
        this.delete(driver.biometricReferenceId);
      }
    });
  }

  delete(id: number) {
    this.service.deleteRegisteredDriver(id).subscribe({
      next: () => {
        this.toast.showToast(
          ts.success,
          'Registro biométrico excluído com sucesso.',
        );
        this.driversList = this.driversList.filter(
          (d) => d.biometricReferenceId !== id,
        );
      },
      error: (e) => {
        const errorMsg =
          e.error && e.error[0] ? e.error[0] : 'Falha ao excluir registro.';
        this.toast.showToast(ts.error, errorMsg);
      },
    });
  }
}
